/**
*** todo: 历史原因，代码亟待优化
**/

import passport from 'model/passport.js'
import md5 from 'assets/lib/md5.js'
import Error from './error';

import {Validate, mailMap, renderHtml} from './helper';
require('../abroad-mobile.js');

$( () => {
    var $mod = $('.module-passport-passwd');
    var sendVerifyEmailCb;
    var count = 60;



    var FCAbroadMobile1 = new window.FCAbroadMobile({
        domain: 'findpwd',
        ctn: '[node-type="pass-container"] .tel-wrap',
        width: 280
    });
    var tel = FCAbroadMobile1.$input;


    var valid = {
        captcha: true,
        submit: true
    };

    var refreshCode = function () {
        var href = $('#validateCode').attr('src') + '?t=' + (new Date()).getTime();
        $('#validateCode').attr('src', href);
    };
    var Event = {
        isSubmit: function (ok, obj) {
            var temp = 0,
                i;

            for (i = 0; i < ok.length; i++) {
                if (ok[i] === 1 || ok[i] === 0) {
                    temp = 1;
                }
            }
            if (temp === 0) {
                obj.removeClass('disabled');
            } else {
                obj.addClass('disabled');
            }
        },
        MobileStep1: function () {
            var val, error = new Error(),
                getCode = $mod.find('.get-code-btn'),
                that = this,
                codeBtn = $mod.find('.code-info-btn'),
                i = 60,
                timer, ok = [0, 0, 0];

            //获取验证码
            getCode.click(function (event) {

                var _self = $(this),
                    val = $.trim(tel.val()),
                    captcha = $mod.find('input[node-type=mobile-picValidate]'),
                    capVal = $.trim(captcha.val());
                if (!valid.captcha) {
                    return;
                }

                valid.captcha = false;
                setTimeout(function () {
                    valid.captcha = true;
                }, 1000);
                //判断手机号
                if (!FCAbroadMobile1.check()) {
                    error.show(tel, error.ErrorTxt[0]);
                    return;
                }
                if (Validate.isEmpty(capVal)) {
                    error.show(captcha, error.ErrorTxt[13]);
                    return;
                }

                //发送ajax请求，成功后回调到这里
                passport.getMobileCaptcha({
                    mobile: val,
                    type: 5,
                    imgcode: capVal,
                    channel: 0,
                    cacode: FCAbroadMobile1.getCode()

                }, function (data) {

                    if (data.errorCode === 0) {
                        getCode.hide().attr('attr-on', '1');

                        codeBtn.html(i + 's后重试').show();
                        var timer = window.setInterval(function () {
                            i--;
                            codeBtn.html(i + 's后重试');
                            if (i <= 0) {
                                window.clearInterval(timer);
                                codeBtn.hide();
                                getCode.show();
                                i = 60;
                            }
                        }, 1000);
                    } else if (data.errorCode === 6) {
                        refreshCode();
                        error.show(captcha, data.errorMessage);

                    }  else {
                        refreshCode();
                        window.alert(data.errorMessage);
                    }
                });
            });

            function checkMobile() {
                var val = $.trim(tel.val());

                if (!FCAbroadMobile1.check()) {
                    error.show(tel, error.ErrorTxt[0]);
                    ok[0] = 1;
                    this.isSubmit(ok, $mod.find('a[node-type=mobile-step1]'));
                    return;
                }
                ok[0] = 2;
                error.hide(tel);
                this.isSubmit(ok, $mod.find('a[node-type=mobile-step1]'));
            }

            //手机号
            $mod.find('.FCMobile-wrap_findpwd').on('input propertychange', function () {
                checkMobile.apply(that)
            });

            tel.on('FCMobile_SELECT', function(e, d) {
                checkMobile.apply(that)
            })

            //图片验证码
            $mod.find('input[node-type=mobile-picValidate]').on('input propertychange', function () {
                val = $.trim($(this).val());
                if (Validate.isEmpty(val)) {
                    error.show($(this), error.ErrorTxt[13]);
                    ok[1] = 1;
                    that.isSubmit(ok, $mod.find('a[node-type=mobile-step1]'));
                    return;
                }
                ok[1] = 2;
                error.hide($(this));
                that.isSubmit(ok, $mod.find('a[node-type=mobile-step1]'));
            });
            //手机验证码
            $mod.find('input[node-type=mobile-telValidate]').on('input propertychange', function () {
                val = $.trim($(this).val());

                if (Validate.isEmpty(val) || $.trim(val).length !== 6) {
                    error.show($(this), error.ErrorTxt[6]);
                    ok[2] = 1;
                    that.isSubmit(ok, $mod.find('a[node-type=mobile-step1]'));

                }
                ok[2] = 2;
                error.hide($(this));
                that.isSubmit(ok, $mod.find('a[node-type=mobile-step1]'));
            });
        },
        emailStep1: function () {
            var val, error = new Error(),
                that = this,
                ok = [0];

            $mod.find('input[node-type=email-input]').on('input propertychange', function () {
                val = $.trim($(this).val());
                var _self = $(this);
                if (!Validate.isEmail(val)) {
                    error.show(_self, error.ErrorTxt[12]);
                    ok[0] = 1;
                    that.isSubmit(ok, $mod.find('a[node-type=email-step1]'));
                    return;
                }
                ok[0] = 2;
                error.hide(_self);
                that.isSubmit(ok, $mod.find('a[node-type=email-step1]'));
            });
        },
        setPass: function () {
            var val, error = new Error(),
                ok = [0, 0],
                pswd1, pswd2, that = this;
                var pswd1Input = $mod.find("input[node-type='passport-pass1']"),
                    pswd2Input = $mod.find("input[node-type='passport-pass2']");

                function pass1cb(input) {
                    return function() {
                        // 只要改了，先把按钮置灰
                        ok[0] = 1;
                        that.isSubmit(ok, $mod.find('a[node-type=mobile-step2]'));
                        val = input.val();
                        var levelInfo = Validate.pwdLevel(val),
                            level = levelInfo.length,
                            safei = $mod.find('.safe-tip i');
                        safei.removeClass('cur');
                        // 至少8位密码，包括大写、小写、数字、特殊字符中的三种即可
                        // 使用正则匹配
                        var pwReg = new RegExp(/^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9]+$)(?![a-z\W_!@#$%^&*`~()-+=]+$)(?![0-9\W_!@#$%^&*`~()-+=]+$)[a-zA-Z0-9\W_!@#$%^&*`~()-+=]/)
                        if (!pwReg.test(val)) {
                          error.show(input, error.ErrorTxt[15]);
                          return false;
                        }

                        if (level === 3) {
                            safei.addClass('cur');
                        } else if (level === 2) {
                            safei.eq(0).addClass('cur');
                            safei.eq(1).addClass('cur');
                        } else if (level === 1) {
                            safei.eq(0).addClass('cur');
                            if (levelInfo[0] === 'd') {
                                error.show(input, error.ErrorTxt[11]);
                                ok[0] = 1;
                                that.isSubmit(ok, $mod.find('a[node-type=mobile-step2]'));
                                return;
                            }
                        }
                        ok[0] = 2;
                        pswd2 = pswd2Input.val();
                        if (val.length >= 8 && val.length < 16) {
                            if (pswd2) {
                                error.hide($mod.find("input[node-type='passport-pass2']"), error.ErrorTxt[10]);

                                if (val !== pswd2) {
                                    error.show(input, error.ErrorTxt[10]);
                                    ok[0] = 1;
                                    that.isSubmit(ok, $mod.find('a[node-type=mobile-step2]'));
                                    return;
                                } else {
                                    ok[0] = 2;
                                    ok[1] = 2;
                                    error.hide(input);
                                    error.hide($mod.find('a[node-type=mobile-step2]'));
                                }

                            } else {
                                error.hide(input);
                            }
                        } else {
                            error.show(input, error.ErrorTxt[8]);
                            ok[0] = 1;
                            that.isSubmit(ok, $mod.find('a[node-type=mobile-step2]'));
                            return;
                        }
                        that.isSubmit(ok, $mod.find('a[node-type=mobile-step2]'));
                    }
                }

                function pass2cb(input) {
                    return function() {
                        // 只要改了，先把按钮置灰
                        ok[0] = 1;
                        that.isSubmit(ok, $mod.find('a[node-type=mobile-step2]'));
                        val = input.val();
                        pswd1 = pswd1Input.val();
                        var levelInfo = Validate.pwdLevel(val),
                            level = levelInfo.length;
                        // 至少8位密码，包括大写、小写、数字、特殊字符中的三种即可
                        // 使用正则匹配
                        var pwReg = new RegExp(/^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9]+$)(?![a-z\W_!@#$%^&*`~()-+=]+$)(?![0-9\W_!@#$%^&*`~()-+=]+$)[a-zA-Z0-9\W_!@#$%^&*`~()-+=]/)
                        if (!pwReg.test(val)) {
                          error.show(input, error.ErrorTxt[15]);
                          return false;
                        }
                        if (pswd1.length < 8 || pswd1.length >= 16) {
                            error.show(pswd1Input, error.ErrorTxt[8]);
                            ok[0] = 1;
                            that.isSubmit(ok, $mod.find('a[node-type=mobile-step2]'));
                            return;
                        }
                        if (val.length <= 0) {
                            error.show(input, error.ErrorTxt[14]);
                            ok[1] = 1;
                            that.isSubmit(ok, $mod.find('a[node-type=mobile-step2]'));
                            return;
                        }

                        if (pswd1) {
                            error.hide(pswd1Input, error.ErrorTxt[10]);
                            if (val !== pswd1) {
                                error.show(input, error.ErrorTxt[10]);
                                ok[1] = 1;
                                that.isSubmit(ok, $mod.find('a[node-type=mobile-step2]'));
                                return;
                            } else {
                                ok[0] = 2;
                                ok[1] = 2;
                                error.hide(input);
                                error.hide($mod.find('a[node-type=mobile-step1]'));
                            }
                        }

                        if (level === 1 && levelInfo[0] === 'd') {
                            error.show(input, error.ErrorTxt[11]);
                            ok[1] = 1;
                            that.isSubmit(ok, $mod.find('a[node-type=mobile-step2]'));
                            return;
                        }

                        ok[1] = 2;
                        that.isSubmit(ok, $mod.find('a[node-type=mobile-step2]'));

                    }
                }
                if(navigator.appName == "Microsoft Internet Explorer" && navigator.appVersion.match(/9./i)=="9.") {
                    pswd1Input[0].attachEvent('oninput', pass1cb(pswd1Input));
                    pswd2Input[0].attachEvent('oninput', pass2cb(pswd2Input));

                    pswd1Input[0].attachEvent('onkeyup', function(e){
                        if(e.keyCode === 8){
                         //删除--触发
                         pswd1Input[0].fireEvent('oninput');
                        }

                    });
                    pswd2Input[0].attachEvent('onkeyup', function(e){
                        if(e.keyCode === 8){
                         //删除--触发
                         pswd2Input[0].fireEvent('oninput');
                        }

                    });
                }

                pswd1Input.on('input propertychange', pass1cb(pswd1Input))

            //确认密码
                pswd2Input.on('input propertychange', pass2cb(pswd2Input))
        }
    };

    var Form = function () {
        this.state = 11;
        this.renderHtml = renderHtml;
    };

    Form.prototype = {
        init: function () {
            // 发送邮件回来要显示
            var emailToken = $mod.find('input[node-type=token]').val(),
                validToken = $mod.find('input[node-type=validToken]').val();
            if (emailToken !== '') {
                if (validToken === '-1') {
                    this.state = 25;
                } else {
                    this.state = 23;
                }
            }

            this.action();

            this.event();

        },

        event: function () {
            var error = new Error(),
                that = this,
                telCtn = $mod.find('#phone_getback'),
                mailCtn = $mod.find('#mail_getback'),
                state;

            $('#validateCode').click(function () {
                refreshCode();
            });
            $mod.find('.type-menu').on('click', 'a', function () {
                var curTabItem = $(this);
                if (curTabItem.hasClass('cur')) {
                    return;
                }
                var index = curTabItem.index();
                $mod.find('.type-menu a.cur').removeClass('cur');
                curTabItem.addClass('cur');

                if (!that.save_state) {
                    that.save_state = that.state;

                }
                that.tmp = that.state;

                if (index === 0) {
                    if (that.save_state > 20) {
                        that.state = 11

                    } else
                        that.state = that.save_state

                } else if (index === 1) {
                    if (that.save_state < 20) {
                        that.state = 21

                    } else
                    that.state = that.save_state


                }
                that.action(true);
                that.save_state = that.tmp;

            });

            //input表格获取焦点 错误提示消息
            $mod.delegate('input', 'focus', function (event) {
                error.hide($(this));
            });

            //邮箱修改回调
            sendVerifyEmailCb = function (data) {

                if (data.errorCode === 0) {
                    that.state = state || 22;
                    $mod.find('input[node-type=email]').val(data.data.email);
                    $mod.find('input[node-type=userName]').val(data.data.userName);
                    that.action();
                } else {
                    window.alert(data.errorMessage);
                }
            };
            //完成验证后的动作
            $mod.delegate('.submit-btn', 'click', function (event) {

                if (!valid.submit) {
                    return;
                }

                valid.submit = false;
                setTimeout(function () {
                    valid.submit = true;
                }, 1000);
                state = parseInt($(this).attr('next-step'), 10);
                switch (state) {
                case 12:
                    var mobile = $.trim(FCAbroadMobile1.$input.val()),
                        captcha = $.trim($mod.find('input[node-type=mobile-telValidate]').val());

                    if (!$(this).hasClass('disabled')) {
                        passport.passwordVerifyCaptcha(mobile, captcha, FCAbroadMobile1.getCode(), function (data) {
                            if (data.errorCode === 0) {
                                that.state = state;
                                that.mobileToken = data.data.token;
                                that.action();
                            } else if (data.errorCode === 1) {
                                error.show($mod.find('input[node-type=mobile-telValidate]'), error.ErrorTxt[6]);
                            } else {
                                window.alert(data.errorMessage);
                            }
                        });
                    }
                    break;
                case 13:
                    if (!$(this).hasClass('disabled')) {
                        passport.resetByMobile(that.mobileToken || '', md5($mod.find('input[node-type=passport-pass1]').val()), function (data) {
                            if (data.errorCode === 0) {
                                that.state = state;
                                that.action();
                            } else {
                                window.alert(data.errorMessage);
                            }
                        });
                    }
                    break;
                case 22:
                    if (!$(this).hasClass('disabled')) {
                        passport.sendVerifyEmail($.trim($mod.find('input[node-type=email-input]').val()), '1', sendVerifyEmailCb);
                    }
                    break;
                case 24:
                    if (!$(this).hasClass('disabled')) {
                        passport.resetByEmail($mod.find('input[node-type=token]').val(), md5($mod.find('input[node-type=passport-pass1]').val()), function (data) {
                            if (data.errorCode === 0) {
                                that.state = state;
                                that.action();
                            } else {
                                window.alert(data.errorMessage);
                            }
                        });
                    }
                    break;
                }
            });

        },
        action: function (stop) {
            var that = this,
                num,
                menu,
                telCtn = $mod.find('#phone_getback'),
                mailCtn = $mod.find('#mail_getback'),
                state = that.state;
            $mod.find('.type-menu a').removeClass('cur');

            if (this.state > 20) {
                $($mod.find('.type-menu a')[1]).addClass('cur');
                menu = $('#mail_getback');
                telCtn.hide();
                mailCtn.show();
            } else {
                $($mod.find('.type-menu a')[0]).addClass('cur');
                menu = $('#phone_getback');
                mailCtn.hide();
                telCtn.show();
            }

            menu.find('li').each(function (index) {
                var arr = this.className.split('-');
                num = parseInt(state, 10) % 10;
                if (num > index) {
                    this.className = arr[0] + '-' + 'done';
                } else {
                    this.className = arr[0] + '-' + 'todo';
                }
            });
            switch (this.state) {
            case 11:
                Event.MobileStep1();
                break;
            case 23:
                menu.find('div[node-type=pass-container]').html(this.renderHtml[0]);
                Event.setPass();
                menu.find('.submit-btn').attr('next-step', 24);
                break;
            case 12:
                menu.find('div[node-type=pass-container]').html(this.renderHtml[0]);
                Event.setPass();
                menu.find('.submit-btn').attr('next-step', 13);
                break;
            case 21:
                Event.emailStep1();
                break;
            case 22:
                var email = $mod.find('input[node-type=email]').val() || $.trim($mod.find('input[node-type=email-input]').val());
                var userName = $mod.find('input[node-type=userName]').val() || email;
                this.email = email;
                menu.find('div[node-type=pass-container]').html(this.renderHtml[1]);
                menu.find('.sended-mail').html(this.hiddenMail(email));
                //前入立即验证
                $('.goto-mail-btn').on('click', function () {

                    var url = email.split('@')[1];
                    window.location.href = mailMap[url];
                });


                this.countDown(stop);


                //重新发送
                $('.s-z-container').on('click', '.resend', function (event) {
                    count = 60;
                    var userName = $mod.find('input[node-type=userName]').val() || $mod.find('input[node-type=email-input]').val();
                    passport.sendVerifyEmail($.trim(userName), '1', sendVerifyEmailCb);
                });
                break;
            case 13:
            case 24:
                menu.find('div[node-type=pass-container]').html(this.renderHtml[2]);
                break;
            case 25:
                menu.find('div[node-type=pass-container]').html(this.renderHtml[3]);
                //重新发送
                $('.resend').click(function (event) {
                    event.preventDefault();
                    var userName = $mod.find('input[node-type=userName]').val() || $mod.find('input[node-type=email-input]').val();
                    passport.sendVerifyEmail($.trim(userName), '1', sendVerifyEmailCb);
                });
                break;
            }
        },
        // 倒计时60s, 到期显示重新发送
        countDown: function (stop) {


            var msgWrap = $('.send-msg-wrap'),
                autotimer;

            msgWrap.html('已发送<b><i class="time-count">' + count + '</i>s</b>后重新发送');
            if (stop) {
                return;
            }

            autotimer = window.setInterval(function () {
                count--;
                if (count === 0) {
                    window.clearInterval(autotimer);
                    msgWrap.html('没收到邮件？<b class="resend">请重新发送</b>');
                    msgWrap.removeClass('disabled');
                    return;
                }
                $('.time-count').html(count);
            }, 1000);
        },
        hiddenMail: function (mail) {
            return mail.replace(/^(.*?)(.{0,4})@/, function ($, $1) {
                return $1 + '****@';
            });
        }
    };
    var form = new Form();
    form.init();

});



// WEBPACK FOOTER //
// ./src/module/passport-password/passport-password.js